import {TextSearchFilterComponent} from './text-search-filter/text-search-filter.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CacheDataService} from '../../api/services/cache-data.service';
import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {Title} from '../../api/models/title';

@Component({
  selector: 'title-search',
  templateUrl: './text-search-filter/text-search-filter.component.html',
  styleUrls: ['./text-search-filter/text-search-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TitleSearchComponent),
      multi: true
    }
  ]
})
export class TitleSearchComponent extends TextSearchFilterComponent<Title> implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('scrollDiv') scrollDiv : ElementRef;

  @Input() fixedHeight?: number;
  @Input() requestNewSearch : (titleNames: string[], pageNumber: number, pageSize: number) => Promise<{totalPages: number, titles: Title[]}>;
  @Input() requestNextBatch : (titleNames: string[], pageNumber: number, pageSize: number) => Promise<{totalPages: number, titles: Title[]}>;

  @Output() dataLoadComplete = new EventEmitter<void>();

  constructor(cacheDataService: CacheDataService, ngZone: NgZone) {
    super(cacheDataService, ngZone);
  }

  protected getHeightValue() : number | undefined {
    if (this.fixedHeight) {
      return this.fixedHeight;
    }
    return undefined;
  }

  ngOnInit() {
    this.callNgOnInit();
  }

  ngAfterViewInit() {
    this.callNgAfterViewInit();
  }

  public dataUpdated() {
    this.newSearch();
  }

  protected getDivScroller(): ElementRef {
    return this.scrollDiv;
  }

  protected isSelected(target: Title) : boolean {
    const exists = this._value && this._value.selectedValues && this._value.selectedValues.find(x => x.key === target.key);
    return !!exists;

  }

  protected getDisplay(target: Title): string {
    return target.name;
  }

  protected async newSearch() {
    this.reloading = true;
    const result = await this.requestNewSearch(this._value?.searchTerms ?? [], 1, 100);

    this.currentPage = 1;
    this.totalPages = result.totalPages;
    this.sourceValues = result.titles;
    this.reloading = false;
    this.dataLoadComplete.emit();
  }

  protected async getNextBatch() {
    if (this.currentPage < this.totalPages) {
      this.loading = true;
      this.currentPage++;
      const result = await this.requestNextBatch(this._value?.searchTerms ?? [], this.currentPage, 100);

      this.totalPages = result.totalPages;
      this.loading = false;
      this.sourceValues = [...this.sourceValues, ...result.titles];
      this.dataLoadComplete.emit();
    }
  }

  protected getSearchPlaceholder(): string {
    return 'Search Titles...';
  }
}
